import floor from 'lodash/floor';
import { CanvasType, IImageLayerProps, ILayerProps, PosterType } from '@/version-types';
import { pointRelation } from './math-kit';

/**
 * 判断是否是 PPT
 *
 * @param type - 画布类型
 */
export const checkCanvasTypeIsPPT = (type: CanvasType) => {
    if (CanvasType.PPT === type) {
        return true;
    }

    return false;
};

/**
 * 判断是否是普通 PPT
 *
 * @param postType - 海报类型
 */
export const checkPosterTypeIsNormalPPT = (postType: PosterType) => {
    if (PosterType.NormalPPT === postType) {
        return true;
    }

    return false;
};

/**
 * 判断是否是 AI PPT
 *
 * @param postType - 海报类型
 */
export const checkPosterTypeIsAiPPT = (postType: PosterType) => {
    if (PosterType.AiPPT === postType) {
        return true;
    }

    return false;
};

export const computeAutoScale = (
    stageWidth: number,
    stageHeight: number,
    width: number,
    height: number,
    viewPortPadding: number,
    hasViewPortPadding = true,
) => {
    const padding = hasViewPortPadding ? viewPortPadding : 0;
    const scaleWidth = Math.max(1, stageWidth / width);
    const scaleHeight = Math.max(1, stageHeight / height);
    const widthScale = stageWidth > width ? scaleWidth : (stageWidth - padding) / width;
    const heightScale = stageHeight > height ? scaleHeight : (stageHeight - padding) / height;

    return floor(widthScale < heightScale ? widthScale : heightScale, 2);
};

export const getStageAndMainLayerCenterPoint = (mainLayer: ILayerProps) => {
    const {
        top: originMainLayerTop,
        left: originMainLayerLeft,
        width: originStageWidth,
        height: originStageHeight,
    } = mainLayer;

    const data = mainLayer.data as IImageLayerProps;
    const { naturalWidth: natureMainLayerWidth, naturalHeight: natureMainLayerHeight, imageTransform } = data;

    const { scale: originMainLayerScale } = imageTransform;

    const stageCenterPoint = {
        x: originStageWidth / 2,
        y: originStageHeight / 2,
    };

    const originMainLayerCenterPoint = {
        x: originMainLayerLeft + (natureMainLayerWidth * originMainLayerScale) / 2,
        y: originMainLayerTop + (natureMainLayerHeight * originMainLayerScale) / 2,
    };

    // 主图中心点和舞台的相对位置
    const originRelativeStagePoint = pointRelation(stageCenterPoint, originMainLayerCenterPoint);

    return {
        stageCenterPoint,
        originMainLayerCenterPoint,
        originRelativeStagePoint,
    };
};
